import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

const Loading =  (color,height,width)  =>{
    return(
      <ClipLoader
      type="Puff"
      color={color}
      height={height}
      width={width}
      timeout={30000} //3 secs
   />
    );
  }

  export default Loading;